require('./rating-widget.styles.less');
require('./rating-widget-template.html');

var playing;

angular.module('bbl.directives')

.directive('ratingWidget', [function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'rating-widget-template.html',
    scope: { rating: '=' }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/rating-widget/rating-widget.controller.js
 ** module id = 190
 ** module chunks = 0
 **/